import {GetDashboardDataUseCase} from '../../domain/dashboard/usecases/GetDashboardDataUseCase';
import {GetDeliveriesByCreatedUserUseCase} from '../../domain/dashboard/usecases/GetDeliveriesByCreatedUserUseCase';
import {DashboardData, RecentScan} from '../../domain/dashboard/entities/DashboardData';

export class DashboardService {
  constructor(
    private readonly getDashboardDataUseCase: GetDashboardDataUseCase,
    private readonly getDeliveriesByCreatedUserUseCase: GetDeliveriesByCreatedUserUseCase,
  ) {}

  async getDashboardData(): Promise<DashboardData> {
    return await this.getDashboardDataUseCase.execute();
  }

  async getDeliveriesByCreatedUser(): Promise<RecentScan[]> {
    return await this.getDeliveriesByCreatedUserUseCase.execute();
  }
}

